import React, { useRef } from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
// material
import { styled, useTheme } from "@mui/material/styles";
import { Box, Card, CardContent, CardMedia, Divider, Rating, Tooltip, Typography, } from "@mui/material";
// utils
import { CarouselControlsPagingBelow } from "./controls";
import ImgLabel from "../machines/ImgLabel";
import moment from 'moment';
import { Link, useNavigate } from "react-router-dom";
import RedirectButton from "../RedirectButton";
import CountryFlag from "../CountryFlag";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import ReactCountryFlag from "react-country-flag";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  overflow: "hidden",
  position: "relative",
  "&:before, &:after": {
    top: 0,
    left: 0,
    zIndex: 8,
    width: 48,
    content: "''",
    height: "100%",
    display: "none",
    position: "absolute",
    [theme.breakpoints.up(480)]: {
      display: "block",
    },
  },
  "&:after": {
    right: 0,
    left: "auto",
    transform: "scaleX(-1)",
  },
  "& .slick-track": {
    display: "inline-flex",
  },
  "& .slick-arrow": {
    display: "none !important",
  },
}));

// ----------------------------------------------------------------------

CarouselItem.propTypes = {
  item: PropTypes.object,
};

function CarouselItem({ item }) {
  const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
  const formatTitle = str => str.length > 63 ? str.substring(0, 63).concat('...') : str;

  const navigate = useNavigate();

  const goToDetail = (item) => {
    return navigate(`/maquinas/${item.Seo.Slug}`)
  }
  return (
    <Link to={`/maquinas/${item.Seo.Slug}`} style={{ textDecoration: 'none' }}>
      <Card sx={{
        mx: 2,
        mb: 3,
        width: 250,
        height: 505,
        position: 'relative',
        cursor: 'pointer'
      }}>
        <Box sx={{ position: 'relative' }}>
          <CardMedia
            component="img"
            loading='lazy'
            alt={item.Imagenes[0].Alt}
            image={item.Imagenes[0].Imagen}
            width='100%'
            height='100%'
            sx={{
              maxHeight: 238,
              height: 190,
              maxWidth: { md: 256 },
              width: '100%',
              objectFit: { xs: 'cover' }
            }}
          />
          <ReactCountryFlag
            countryCode={item.Pais}
            svg
            style={{
              position: 'absolute',
              top: 10,
              right: 10,
              // width: '25px',
              width: '2em',
              height: '2em',
            }}
            title={item.Pais}
          />
          {/*<CountryFlag src='/static/dummy/chile-flag.png' />*/}
        </Box>

        {
          item.Texto_Promocional &&
          <ImgLabel label={item.Texto_Promocional} />
        }
        {
          item.Es_Nuevo &&
          <ImgLabel label='Nuevo' secondLabel={item.Texto_Promocional} />
        }
        <Divider />
        <CardContent>
          <Typography variant="caption" color="primary.dark">
            {item.Marca_Producto}
          </Typography>
          <Typography variant="h6">{item.Nombre_Producto}</Typography>
          <Box sx={{ minHeight: '106px' }}>
            {
              item.Precio_Producto ?
                <>
                  <Typography variant="caption">Venta</Typography>
                  <Typography variant="h6" color="primary.dark" sx={{ mb: 1 }}>
                    $ {addCommas(removeNonNumeric(item.Precio_Producto))} + IVA
                  </Typography>
                </>
                : <></>
            }

            {
              item.Precio_Arriendo ?
                <>
                  <Typography variant="caption">Arriendo</Typography>
                  <Typography variant="h6" color="secondary.dark" sx={{ mb: 1 }}>
                    $ {addCommas(removeNonNumeric(item.Precio_Arriendo))} + IVA
                  </Typography>
                </>
                : <></>
            }
          </Box>

          <Box sx={{ my: 2 }}>
            <Typography variant='body1'>
              Nota:
            </Typography>
            <Tooltip title={
              <>
                {
                  item.Puntajes.map((el, i) => (
                    <Typography key={el._id}>{el.Texto}: {el.Valor} / 7</Typography>
                  ))
                }
              </>
            }>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <MilitaryTechIcon color='primary' />
                <Typography variant='h5'>
                  {item.Puntaje_Total} /
                  <span style={{ fontSize: '16px', marginLeft: '5px' }}>7</span>
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        </CardContent>
      </Card>
    </Link>
  );
}

function CarouselItemNews({ currentNew }) {
  const navigate = useNavigate();

  const formatTitle = (string) => {
    if (string.length > 60) {
      return string.substring(0, 57).concat('...')
    } else {
      return string;
    }
  }

  const goToDetail = (item) => {
    return navigate(`/noticias/${item.Codigo}`)
  }


  return (
    <Card onClick={() => goToDetail(currentNew)} sx={{
      mx: 2,
      mb: 3,
      position: 'relative',
    }}>
      <CardMedia
        component="img"
        sx={{
          height: '150px'
        }}
        image={currentNew.Banner_Desktop}
        alt="green iguana"
      />
      <Divider />
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>{formatTitle(currentNew.Titulo)}</Typography>

        <Typography variant="h6" color="#527701" sx={{ mb: 1 }}>
          {moment(currentNew.Fecha_Publicacion, 'YYYYMMDD').fromNow()}
        </Typography>
      </CardContent>
    </Card>
  )

}

export default function CarouselCenterMode({ type, arr }) {
  const carouselRef = useRef();
  const theme = useTheme();

  const settings = {
    dots: true,
    slidesToShow: 4,
    infinite: false,
    // centerMode: true,
    // centerPadding: "60px",
    // rtl: Boolean(theme.direction === "rtl"),
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1.35, centerPadding: "0" },
      },
    ],
    ...CarouselControlsPagingBelow({
      sx: { mt: 3 },
    }),
  };

  if (type === 'products') {
    return (
      <RootStyle>
        <Slider ref={carouselRef} {...settings}>
          {arr.map((item) => (
            <CarouselItem key={item._id} item={item} />
          ))}
        </Slider>
      </RootStyle>
    );
  } else if (type === 'news') {
    return (
      <RootStyle>
        <Slider ref={carouselRef} {...settings}>
          {arr.map((item) => (
            <CarouselItemNews key={item._id} currentNew={item} />
          ))}
        </Slider>
      </RootStyle>
    );
  }

}
